@if (merchants().length > 0) {
  @if (hasChoice()) {
    <button
      mat-stroked-button
      class="merchant-selector-trigger max-w-56 sm:max-w-72"
      [matMenuTriggerFor]="merchantMenu"
    >
      <mat-icon
        class="icon-size-5 text-hint shrink-0"
        [svgIcon]="'heroicons_outline:building-storefront'"
      ></mat-icon>
      <span class="min-w-0 flex-auto truncate text-left">
        {{ selectedMerchantLabel() }}
      </span>
      <mat-icon
        class="icon-size-4 text-hint shrink-0"
        [svgIcon]="'heroicons_outline:chevron-up-down'"
      ></mat-icon>
    </button>

    <mat-menu #merchantMenu="matMenu" class="merchant-selector-menu">
      @for (merchant of merchants(); track merchant.id) {
        <button
          mat-menu-item
          (click)="onChange(merchant.id)"
        >
          <mat-icon
            class="icon-size-4"
            [class.opacity-0]="merchant.id !== selectedMerchantId()"
            [svgIcon]="'heroicons_outline:check'"
          ></mat-icon>
          <span>{{ merchant.tradeName || merchant.name }}</span>
        </button>
      }
    </mat-menu>
  } @else {
    <span class="merchant-selector-badge">
      <mat-icon
        class="icon-size-5 text-hint shrink-0"
        [svgIcon]="'heroicons_outline:building-storefront'"
      ></mat-icon>
      <span class="truncate">{{ selectedMerchantLabel() }}</span>
    </span>
  }
}
